import "core-js/modules/es.error.cause.js";

// 从当前 url 创建导出的 url （约定为固定url)
const getDefaultUrl = () => {
  const fullPath = location.pathname; // 当前请求路径

  const [_, app = '', context = ''] = fullPath.split('/');
  return `/${app}/${context}/emapcomponent/imexport/export.do`;
}; // 拼接文件下载链接


const getDefaultFilePath = attachment => {
  const fullPath = location.pathname; // 当前请求路径

  const [_, app = '', context = ''] = fullPath.split('/');
  return `/${app}/${context}/emapcomponent/file/getAttachmentFile/${attachment}.do`;
};
/**
 * 导出表格数据到文件
 * @param {Object} params 导出配置
 */


export const exportDataTable = (params = {}) => {
  const {
    url,
    getFilePath,
    method = 'POST',
    app,
    module,
    page,
    action,
    cols = [],
    filename,
    query = {}
  } = params;
  let queryUrl = url || getDefaultUrl();
  const colnames = cols.map(item => {
    return typeof item === 'string' ? item : item.name;
  }).join(',');
  const queryParams = {
    app,
    //导出app的名称
    module,
    //页面模块名称
    page,
    //页面名称
    action,
    //页面动作
    colnames,
    //需要导出的列,用逗号分开的字符串
    filename,
    //导出的文件名字
    querySetting: query || '' //高级查询的条件
    // querySetting: '[{"name":"AUTHOR_NAME","caption":"拟稿人姓名","linkOpt":"AND","builderList":"cbl_String","builder":"include","value":"222"},{"name":"DEPT_NAME","caption":"拟稿部门","linkOpt":"AND","builderList":"cbl_String","builder":"include","value":"333"}]', 

  }; // const postData = new FormData()

  const postData = Object.keys(queryParams).map(key => `${key}=${queryParams[key]}`).join('&'); // for (let key in queryParams) {
  //   postData.append(key, params[key])
  // }

  return fetch(queryUrl, {
    method,
    body: postData,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    },
    credentials: 'include'
  }).then(res => res.json()).then(res => {
    if (res && res.status === '1') {
      return res.attachment;
    }

    throw new Error('导出请求失败');
  }).then(attachment => {
    const fileUrl = getFilePath ? getFilePath(attachment) : getDefaultFilePath(attachment);
    location.href = fileUrl;
  });
};